<template>
    <div class="scroll-container">
        <div style="display: flex;align-items: center;" @click="navBack">
            <img :src="$staticUrl('/statics/2025/09/13/return_20250913141253A062.png')" alt="" style="width: 14px;height: 14px;vertical-align: bottom;"></img>
            <div style="color: #fff; margin-left: 5px;font-size: 15px;">返回</div>
        </div>
        <div style="display: flex;justify-content: space-between;flex:1;margin-top:15px;">
            <div class="detail">
                <div style="color: #fff;font-size: 15px;font-weight: bold;">工单详情</div>
                <div style="display: flex;margin-top: 30px; border-bottom: 2px solid #1E524F;padding-bottom: 15px;">
                    <div style="display: flex;flex-direction: column; flex:1">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">工单编号</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;">{{ info.no }}</div>
                    </div>
                    <div style="display: flex;flex-direction: column; flex:1">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">所在位置</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;">{{ info.reportAddress }}</div>
                    </div>
                    <div style="display: flex;flex-direction: column; flex:1">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">提交时间</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;">{{ info.createTime }}</div>
                    </div>
                </div>
                <div style="display: flex;margin-top: 20px; border-bottom: 2px solid #1E524F;padding-bottom: 15px;">
                    <div style="display: flex;flex-direction: column; flex:1">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">事件类型</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;" v-if="info.reportType === '0'">业主报修</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;" v-if="info.reportType === '1'">保洁</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;" v-if="info.reportType === '2'">工程维修</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;" v-if="info.reportType === '3'">投诉建议</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;" v-if="info.reportType === '4'">其他</div>

                    </div>
                    <div style="display: flex;flex-direction: column; flex:1">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">提交人</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;">{{ info.reportName }}</div>
                    </div>
                    <div style="display: flex;flex-direction: column; flex:1">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">联系方式</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;">{{ info.phone }}</div>
                    </div>
                </div>
                <div style="display: flex;margin-top: 20px; border-bottom: 2px solid #1E524F;padding-bottom: 15px; flex:1">
                    <div style="display: flex;flex-direction: column;">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">问题描述</div>
                        <div style="font-size: 13px;color: #fff;margin-top: 10px;">{{ info.reportRemark }}</div>
                    </div>
                </div>
                <div style="display: flex;margin-top: 20px;height: 240px;">
                    <div style="display: flex;flex-direction: column;">
                        <div style="font-size: 15px;color: rgba(255,255,255,0.6);">现场照片</div>
                        <div style="display: flex;flex-wrap: wrap;">
                            <div style="margin-top: 10px;margin-right: 10px;" v-for="(item, index) in info.reportImages" :key="index">
                                <el-image style="width: 160px; height: 160px;border-radius: 8px;" :src="item" fit="cover"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="progress">
                <el-steps :active="1" direction="vertical" finish-status="success" space="100px">
                    <el-step status="success" v-if="Number(info.reportStatus) >= 0">
                        <template #icon>
                            <i class="el-icon-success"></i>
                        </template>
                        <template #title>
                            <div style="color:#fff;font-size:15px;margin-top:5px;font-weight: bold;">工单提交成功</div>
                        </template>
                        <template #description>
                            <div style="color: rgba(255,255,255,0.6);font-size:13px;">系统已收到您的维修申请</div>
                        </template>
                    </el-step>
                    <el-step status="success" v-if="Number(info.reportStatus) >= 1">
                        <template #icon>
                            <i class="el-icon-success"></i>
                        </template>
                        <template #title>
                            <div style="color:#fff;font-size:15px;margin-top:5px;font-weight: bold;">物业已受理</div>
                        </template>
                        <template #description>
                            <div style="color: rgba(255,255,255,0.6);font-size:13px;">工单已分配至维修部</div>
                        </template>
                    </el-step>
                    <el-step status="success" v-if="Number(info.overTimed) == 1">
                        <template #icon>
                            <i class="el-icon-success"></i>
                        </template>
                        <template #title>
                            <div style="color:#fff;font-size:15px;margin-top:5px;font-weight: bold;">工单已超时</div>
                        </template>
                        <template #description>
                            <div style="color: rgba(255,255,255,0.6);font-size:13px;">工单已超时</div>
                        </template>
                    </el-step>
                    <el-step status="success" v-if="Number(info.reportStatus) >= 2">
                        <template #icon>
                            <i class="el-icon-success"></i>
                        </template>
                        <template #title>
                            <div style="color:#fff;font-size:15px;margin-top:5px;font-weight: bold;">业主评价中</div>
                        </template>
                        <template #description>
                            <div style="color: rgba(255,255,255,0.6);font-size:13px;">等待业主评价</div>
                        </template>
                    </el-step>
                    <el-step status="success" v-if="Number(info.reportStatus) >= 3">
                        <template #icon>
                            <i class="el-icon-success"></i>
                        </template>
                        <template #title>
                            <div style="color:#fff;font-size:15px;margin-top:5px;font-weight: bold;">工单完成</div>
                        </template>
                        <template #description>
                            <div style="color: rgba(255,255,255,0.6);font-size:13px;">工单已完成</div>
                        </template>
                    </el-step>
                </el-steps>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    props: {
        info: { type: Object, default: () => {} }
    },
    data() {
        return {
            info: this.info,
        }
    },
    mounted() {
        
    },
    methods: {
        navBack() {
            this.$router.go(-1);
        }
    }
}
</script>
<style scoped>
/* 样式保持不变 */
.scroll-container {
    padding: 15px;
    width: 1510px;
    height: 710px;
    background: rgba(0,0,0,0.7);
    display: flex;
    flex-direction: column;
}

.detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px;
    background: rgba(18,59,55,0.3);
    border-radius: 8px;
    margin-right: 15px;
}

.progress {
    width: 300px;
    padding: 15px;
    background: rgba(18,59,55,0.3);
    border-radius: 8px;
}

::v-deep .el-step__main {
    background-color: rgba(173, 255, 247, 0.1);
    margin-bottom: 10px;
    margin-left: 10px;
    border-radius: 8px;
    border-color: rgba(173, 255, 247, 0.1);
}

::v-deep .el-step__icon.is-text {
    border:0;
}

::v-deep .el-step__icon {
    background-color: rgba(117, 224, 160, 0.4);
}

::v-deep .el-step__line {
    margin-top: 30px;
    margin-bottom: 5px;
    background-color: rgba(124, 230, 221, 0.4);
}
</style>
    